import { EXPLORE_FILTER_TIME } from './use-experience-filter';
import useSetFilter, { TimeKey } from './use-set-filter';

const useSetTime = () => useSetFilter<TimeKey | undefined>(EXPLORE_FILTER_TIME);

export default useSetTime;
